import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

export const Card: React.FC<CardProps> = ({ children, className = '' }) => {
  const baseClasses = 'rounded-xl border border-gray-700 bg-gray-800 text-white shadow-lg hover:shadow-xl transition-shadow duration-200';
  const classes = `${baseClasses} ${className}`;
  
  return (
    <div className={classes}>
      {children}
    </div>
  );
};

interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ children, className = '' }) => {
  const baseClasses = 'flex flex-col space-y-1.5 p-6';
  const classes = `${baseClasses} ${className}`;
  
  return (
    <div className={classes}>
      {children}
    </div>
  );
};

interface CardContentProps {
  children: React.ReactNode;
  className?: string;
}

export const CardContent: React.FC<CardContentProps> = ({ children, className = '' }) => {
  const baseClasses = 'p-6 pt-0';
  const classes = `${baseClasses} ${className}`;
  
  return (
    <div className={classes}>
      {children}
    </div>
  );
}; 